import React from "react";
import "../../assets/styles/smu-loading.scss";
import loading from "../../assets/images/loading.gif";

const SmuLoading = ({ label }) => {
  return (
    <div className="smu-loading">
      <img src={loading} alt="Cargando" />
      <span className="ms-3">{label || "Cargando..."}</span>
    </div>
  );
};

export default SmuLoading;
